export default __webpack_public_path__ + "static/media/status_updating.bcaf211b.png";